import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { ContactusformComponent } from './components/contactusform/contactusform.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CONTACTUS_FEATURE } from './store/contactUs-state';
import { ContactUsReducer } from './store/reducer/contactUs-reducer';
import { ContactUsPageEffects } from './store/effects/contactUs-effect';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    ContactusformComponent,
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(CONTACTUS_FEATURE, ContactUsReducer),
    EffectsModule.forFeature(ContactUsPageEffects),
    SGRESharedModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ContactUsFormComponent: {
          component: () => import('./components/contactusform/contactusform.component').then(m => m.ContactusformComponent),
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore }
  ]
})
export class ContactUsModule { }